import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { FeatureSection } from '../components/FeatureSection';
import { CrmSection } from '../components/CrmSection';
import { AutomationsSection } from '../components/AutomationsSection';
import { Reputation } from '../components/Reputation';
import { AIReceptionist } from '../components/AIReceptionist';
import { Onboarding } from '../components/Onboarding';
import { AdReporting } from '../components/AdReporting';
import { ClosingCTA } from '../components/ClosingCTA';
import { SEOHead } from '../components/SEOHead';
import { marketing } from '../data/howItWorks';

/* 2026-09-08 (compliance, Kevin): the meta description below used to list
   "reputation" as a pillar. Removed; Yelp flagged Viridia for review
   solicitation. The <Reputation /> section in that slot is now the unified
   inbox, see the comment at the top of components/Reputation.tsx. */

export function HowItWorks() {
  return <>
      <SEOHead title="How It Works | One CRM, AI Receptionist & Marketing System | Viridia Analytics" description="Everything in one system: CRM, AI receptionist, automations, marketing, one unified inbox, and ad reporting, built with you for Phoenix home-service businesses." canonical="/how-it-works" data-id="element-2661" data-mp="10sb6pp06lykk" />

      <PageHeader label="How it works" title="One login. One system. One team." intro="Instead of fifty logins and a vendor for every problem, all of it runs in one place. Solo operator or five crews." data-id="element-2662" data-mp="1e0ry6a1dhspg" />

      <CrmSection data-id="element-2663" data-mp="140ixaiwfrj3q" />

      <AutomationsSection data-id="element-2664" data-mp="1446t5opcshlm" />

      <FeatureSection label="Marketing" title="The cheapest job is the repeat customer." body="Stay in front of the people who already paid you once." features={marketing} alt data-id="element-2665" data-mp="1007c9505vgrq" />

      <Reputation data-id="element-2666" data-mp="2udgr7cbh7uhd" />
      <AIReceptionist data-id="element-2667" data-mp="2udzxfvrrkufk" />
      <Onboarding data-id="element-2668" data-mp="2ucfd0yz5yrvf" />
      <AdReporting data-id="element-2669" data-mp="2pff6yo2bdp4b" />
      <ClosingCTA data-id="element-2670" data-mp="2pevn31t3sqnn" />
    </>;
}